function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTxTfIncidents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 109.36 104.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48,2.2l4.85,21.86a1,1,0,0,0,2-.17L56.13,1.08A1,1,0,0,0,55,0c-1.65.26-4.56.7-6.12,1A1,1,0,0,0,48,2.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.84,4.17,58.53,24.54a1,1,0,0,0,1.72,1.09L75,8.18a1,1,0,0,0-.29-1.56c-1.47-.8-4.06-2.19-5.46-2.93A1,1,0,0,0,67.84,4.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.46,17.7,62.76,28.33a1,1,0,0,0,.71,1.91l22.28-5a1,1,0,0,0,.72-1.42c-.7-1.52-1.92-4.19-2.59-5.62A1,1,0,0,0,82.46,17.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.74,32.88a2.21,2.21,0,0,0-.62-.94L33.61,17.87a2.26,2.26,0,0,0-2.26-.47C26,19.25,8.94,25.58,4.14,27.24a1.91,1.91,0,0,0-1.22,1.55C2.27,33,.41,46.72,0,49.59a2.3,2.3,0,0,0,.1,1l3.4,9.86A2.26,2.26,0,0,0,6.4,61.9l20.92-7.43c2.82-5.58,7.41-14.66,9.15-18a2.24,2.24,0,0,1,1.94-1.25l12.14,0ZM9.89,54.46a4.16,4.16,0,1,1,2.57-5.29A4.17,4.17,0,0,1,9.89,54.46ZM38.18,32.34,8.65,42.92a1.18,1.18,0,0,1-1.56-1.28C7.59,38,8.14,34,8.42,32.25A1.48,1.48,0,0,1,9.37,31c3.74-1.29,16.25-6.05,20.4-7.48a1.77,1.77,0,0,1,1.76.36l7.07,6.41A1.19,1.19,0,0,1,38.18,32.34ZM17,61.65,8.73,64.49l2,6a3,3,0,0,0,3.85,1.88l2.53-.87A3,3,0,0,0,19,67.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.06,81.27a3,3,0,0,0,2,2.83l2.3-9.49H71.06Zm1.81-41.91a2.26,2.26,0,0,0-2-1.17l-30.61.05a1.89,1.89,0,0,0-1.65,1.06C36.66,43,30.41,55.44,29.11,58a2.21,2.21,0,0,0-.24,1V69.47a2.27,2.27,0,0,0,2.27,2.27l44.92,0,1.58-6.5a4.09,4.09,0,0,1-2.21.65A4.16,4.16,0,1,1,79,59.59l1.45-6c0-.12,0-.22.07-.34Zm-36,26.48A4.16,4.16,0,1,1,41,61.68,4.16,4.16,0,0,1,36.86,65.84ZM72.49,54.53h-33a1.19,1.19,0,0,1-1.06-1.72C40,49.54,41.86,46,42.7,44.36A1.49,1.49,0,0,1,44,43.53l23.4,0a1.74,1.74,0,0,1,1.54.92l4.6,8.36A1.18,1.18,0,0,1,72.49,54.53Zm-40,26.74a3,3,0,0,0,3,3h2.67a3,3,0,0,0,3-3V74.61H32.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.36,103.45a1.31,1.31,0,0,1-1.27,1.34H67a1.31,1.31,0,0,1-1.27-1.34l3.53-6.82a1.31,1.31,0,0,1,1.27-1.34h34a1.31,1.31,0,0,1,1.27,1.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.67,75.83,75.11,90.52a1.31,1.31,0,0,0,1.27,1.34H98.74A1.31,1.31,0,0,0,100,90.52L96.44,75.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8,81.42l-6.6-27.2a1.31,1.31,0,0,0-1.27-1.34H85.19a1.3,1.3,0,0,0-1.27,1.34L77.53,80.53Z",
    style: {
      fill: "#fff"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxTfIncidents);
export default __webpack_public_path__ + "static/media/tx_TFIncidents.951e9872e4bac0d331b8e74f85e6e163.svg";
export { ForwardRef as ReactComponent };